const trapFocusHandlers: { [key: string]: EventListenerOrEventListenerObject } = {};

function getFocusableElements(container: HTMLElement) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

export function trapFocus(container: HTMLElement, elementToFocus: HTMLElement = container, preventScroll: boolean = false) {
  const elements = getFocusableElements(container) as HTMLElement[];
  const first = elements[0];
  const last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event: KeyboardEvent) {
    if (event.code.toUpperCase() !== 'TAB') return;

    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus({preventScroll: preventScroll});

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes((elementToFocus as HTMLInputElement).type) &&
    (elementToFocus as HTMLInputElement).value
  ) {
    (elementToFocus as HTMLInputElement).setSelectionRange(0, (elementToFocus as HTMLInputElement).value.length);
  }
}

export function trapFocusDelay(container: HTMLElement, elementToFocus: HTMLElement, preventScroll: boolean = false, delay: number = 0) {
  setTimeout(() => {
    trapFocus(container, elementToFocus, preventScroll)
  }, delay)
}

export function removeTrapFocus(elementToFocus: HTMLElement | null = null, preventScroll = false) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) {
    elementToFocus.focus({preventScroll: preventScroll});
  }
}